import apiClient from "./apiClient";
import {removeNullFields} from "@/utils/utils";
import {TemplateTypeEnum} from "@/enum/TemplateTypeEnum";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const eventService = {
    async getAll(params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/event/all`,
                paramsCopy
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching event list", error);
            throw error;
        }
    },

    async getEventObjectNames(): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/event/getEventObjectNames?includeAll=true`);
            return response.data;
        } catch (error) {
            console.error("Error getEventObjectNames event", error);
            throw error;
        }
    },
    async findById(id: string): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/event/findById/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error findById event", error);
            throw error;
        }
    },



    async exportEventsXls(params: any): Promise<any> {
        try {
            const token = localStorage.getItem("access_token");

            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/event/export/xls`,
                paramsCopy,
                {
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            )
            return response.data;
        } catch (error) {
            console.error("Error export events", error);
            throw error;
        }
    },
}

export default eventService;
